export enum LoggingLevel {
  Default = 'default',
  Off = 'off',
  Verbose = 'verbose',
}

export enum LoggingType {
  Default = 'default',
  Debug = 'debug',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
}
